export enum ItemTypes {
            LOAD = 'LOAD',
            TRUCK = 'TRUCK',
            MATCHED = 'MATCHED'
}
